import { Component } from '@angular/core';

@Component({
  selector: 'lib-container-list-item-empty',
  templateUrl: './container-list-item-empty.component.html',
  styleUrls: ['./container-list-item-empty.component.scss']
})
export class ContainerListItemEmptyComponent {}
